/* ============================================================
   STRUKT — bundle-builder.js
   "Build Your Own Set" page: pick products, see live tier
   progress, add everything to the real Shopify cart at once.

   IMPORTANT: this script only tracks selections and shows tier
   messaging + adds real line items to the cart. It cannot make
   an item free or apply a percentage discount by itself — for
   the price to actually change at checkout, matching Shopify
   Automatic Discounts (Discounts → Buy X Get Y / percentage off)
   must be configured in the admin with the same thresholds.
   ============================================================ */
(function () {
  'use strict';

  var doc = document;
  function qs(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }

  var root = qs('[data-bundle-builder]');
  if (!root) return;

  var config = window.bundleBuilderConfig || { tiers: [] };
  var selections = []; // { variantId, title, price, image }

  var grid = qs('[data-bundle-grid]', root);
  var itemsList = qs('[data-bundle-items]', root);
  var emptyRow = qs('[data-bundle-empty]', root);
  var countEl = qs('[data-bundle-count]', root);
  var subtotalEl = qs('[data-bundle-subtotal]', root);
  var subtotalOriginalEl = qs('[data-bundle-subtotal-original]', root);
  var savingsEl = qs('[data-bundle-savings]', root);
  var checkoutBtn = qs('[data-bundle-checkout]', root);
  var tierMessage = qs('[data-bundle-tier-message]', root);
  var tierRows = qsa('[data-bundle-tier]', root);
  var progressFill = qs('[data-bundle-progress]', root);
  var lastDiscountPercent = 0;

  function formatMoney(cents) {
    return (window.theme && window.theme.moneyFormat
      ? window.theme.moneyFormat.replace('{{amount}}', (cents / 100).toFixed(2))
      : '$' + (cents / 100).toFixed(2));
  }

  /* ---------- category tabs ---------- */
  qsa('[data-bundle-tab]', root).forEach(function (tab) {
    tab.addEventListener('click', function () {
      qsa('[data-bundle-tab]', root).forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      var target = tab.dataset.target;
      qsa('[data-bundle-category]', grid).forEach(function (pick) {
        pick.hidden = target !== 'all' && pick.dataset.bundleCategory !== target;
      });
    });
  });

  /* ---------- selection state ---------- */
  function findSelection(variantId) {
    return selections.filter(function (s) { return s.variantId === variantId; })[0];
  }

  function addSelection(card) {
    var variantId = card.dataset.variantId;
    if (!variantId || findSelection(variantId)) return;
    selections.push({
      variantId: variantId,
      title: card.dataset.productTitle,
      price: parseInt(card.dataset.productPrice, 10) || 0,
      image: card.dataset.productImage
    });
    card.classList.add('is-selected');
    render();
  }

  function removeSelection(variantId) {
    selections = selections.filter(function (s) { return s.variantId !== variantId; });
    var card = qs('[data-bundle-add][data-variant-id="' + variantId + '"]', grid);
    if (card) card.classList.remove('is-selected');
    render();
  }

  qsa('[data-bundle-add]', grid).forEach(function (card) {
    card.addEventListener('click', function () {
      if (card.disabled) return;
      var variantId = card.dataset.variantId;
      if (findSelection(variantId)) {
        removeSelection(variantId);
      } else {
        addSelection(card);
      }
    });
  });

  /* ---------- render summary panel ---------- */
  function render() {
    countEl.textContent = '(' + selections.length + ')';
    checkoutBtn.disabled = selections.length === 0;

    if (selections.length === 0) {
      itemsList.innerHTML = '';
      itemsList.appendChild(emptyRow);
      emptyRow.hidden = false;
    } else {
      emptyRow.hidden = true;
      itemsList.innerHTML = selections.map(function (s) {
        return '<li class="bundle-line" data-variant-id="' + s.variantId + '">' +
          '<img src="' + s.image + '&width=80" alt="">' +
          '<span><span class="bundle-line__title">' + s.title + '</span><br>' +
          '<span class="bundle-line__price">' + formatMoney(s.price) + '</span></span>' +
          '<button type="button" class="bundle-line__remove" data-bundle-remove="' + s.variantId + '" aria-label="Remove">✕</button>' +
          '</li>';
      }).join('');
      qsa('[data-bundle-remove]', itemsList).forEach(function (btn) {
        btn.addEventListener('click', function () { removeSelection(btn.dataset.bundleRemove); });
      });
    }

    var subtotal = selections.reduce(function (sum, s) { return sum + s.price; }, 0);
    var sortedTiers = config.tiers.slice().sort(function (a, b) { return a.threshold - b.threshold; });
    var activeTier = null;
    sortedTiers.forEach(function (tier) {
      if (selections.length >= tier.threshold) activeTier = tier;
    });
    var discountPercent = (activeTier && activeTier.discountPercent) || 0;
    var discountedTotal = discountPercent > 0 ? Math.round(subtotal * (100 - discountPercent) / 100) : subtotal;
    var savedAmount = subtotal - discountedTotal;

    if (discountPercent > 0 && subtotal > 0) {
      subtotalOriginalEl.textContent = formatMoney(subtotal);
      subtotalOriginalEl.hidden = false;
      subtotalEl.textContent = formatMoney(discountedTotal);
      subtotalEl.classList.add('is-discounted');
      savingsEl.hidden = false;
      savingsEl.textContent = '🎉 ' + discountPercent + '% off applied — you save ' + formatMoney(savedAmount) + '!';
    } else {
      subtotalOriginalEl.hidden = true;
      subtotalEl.textContent = formatMoney(subtotal);
      subtotalEl.classList.remove('is-discounted');
      savingsEl.hidden = true;
      savingsEl.textContent = '';
    }

    if (discountPercent !== lastDiscountPercent) {
      var burst = discountPercent > lastDiscountPercent;
      lastDiscountPercent = discountPercent;
      if (burst && discountPercent > 0) {
        [subtotalEl, savingsEl].forEach(function (el) {
          el.classList.remove('is-popping');
          void el.offsetWidth; /* restart animation */
          el.classList.add('is-popping');
        });
      }
    }

    renderTiers();
  }

  function renderTiers() {
    var count = selections.length;
    var sortedTiers = config.tiers.slice().sort(function (a, b) { return a.threshold - b.threshold; });
    var nextTier = null;

    tierRows.forEach(function (row) {
      var threshold = parseInt(row.dataset.threshold, 10);
      row.classList.toggle('is-reached', count >= threshold);
    });

    sortedTiers.forEach(function (tier) {
      if (count < tier.threshold && !nextTier) nextTier = tier;
    });

    if (progressFill) {
      var pct = 0;
      if (nextTier) {
        pct = Math.min(100, Math.round((count / nextTier.threshold) * 100));
      } else if (sortedTiers.length) {
        pct = 100;
      }
      progressFill.style.width = pct + '%';
      progressFill.classList.toggle('is-complete', pct >= 100 && !!sortedTiers.length);
    }

    if (!tierMessage) return;
    if (count === 0 && sortedTiers.length) {
      var first = sortedTiers[0];
      tierMessage.textContent = 'Add ' + first.threshold + ' products to unlock ' + first.label + '.';
    } else if (nextTier) {
      var remaining = nextTier.threshold - count;
      tierMessage.textContent = 'Add ' + remaining + ' more to unlock: ' + nextTier.label;
    } else if (sortedTiers.length) {
      tierMessage.textContent = 'You’ve unlocked every tier — nice.';
    }
  }

  /* ---------- add everything to cart ---------- */
  checkoutBtn.addEventListener('click', function () {
    if (!selections.length) return;
    checkoutBtn.disabled = true;
    checkoutBtn.textContent = 'Adding…';

    var items = selections.map(function (s) { return { id: s.variantId, quantity: 1 }; });

    var count = selections.length;
    var sortedTiers = config.tiers.slice().sort(function (a, b) { return a.threshold - b.threshold; });
    var activeTier = null;
    sortedTiers.forEach(function (tier) {
      if (count >= tier.threshold) {
        activeTier = tier;
        if (tier.giftVariantId) items.push({ id: tier.giftVariantId, quantity: 1 });
      }
    });

    fetch((window.routes && window.routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          window.dispatchEvent(new CustomEvent('strukt:toast', { detail: data.description || 'Could not add your set to the cart.' }));
          checkoutBtn.disabled = false;
          checkoutBtn.textContent = 'Add Set to Cart';
          return;
        }
        var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
        if (activeTier && activeTier.discountCode) {
          /* Applying the discount this way (rather than a store-wide Automatic
             Discount) is what makes the tiered discount exclusive to the BYB flow —
             a customer who just adds the same products individually never hits
             this URL, so they never get the code. */
          window.location.href = '/discount/' + encodeURIComponent(activeTier.discountCode) + '?redirect=' + encodeURIComponent(cartUrl);
        } else {
          window.location.href = cartUrl;
        }
      })
      .catch(function () {
        window.dispatchEvent(new CustomEvent('strukt:toast', { detail: 'Something went wrong. Please try again.' }));
        checkoutBtn.disabled = false;
        checkoutBtn.textContent = 'Add Set to Cart';
      });
  });

  render();
})();
